import { render, staticRenderFns } from "./covid-infomation.vue?vue&type=template&id=5882c950&"
import script from "./covid-infomation.vue?vue&type=script&lang=js&"
export * from "./covid-infomation.vue?vue&type=script&lang=js&"
import style0 from "./covid-infomation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports